import Vue from 'vue';
import Router from 'vue-router';
const _import = require('./_import_' + process.env.NODE_ENV);

Vue.use(Router);

// 测试页面
const checkone = r => require.ensure([], () => r(require('@/test/checkone.vue')), 'checkone');

const originalPush = Router.prototype.push // 点击element-ui 子菜单 两次报错解决
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
// 配置路由
export default new Router({
  // mode: 'history',
  routes: [{
    path: '/projectLibrary',
    component: _import('projectLibrary/index'),
    children: [{
      path: 'projectMain',
      component: _import('projectLibrary/projectMain/projectMain'),
      name: 'projectLibrary'
    }]
  },
    {
      path: '/empty',
      name: 'empty',
      component: _import('login/empty')
    },
  {
    path: '/jDoctorLogin',
    name: 'jDoctorLogin',
    component: _import('mobileEntranceIndex/login')
  },
  {
    path: '/proDetails',
    component: _import('proDetails/proDetails'),
    children: [{
      path: 'proDetails/:paramId',
      component: _import('proDetails/proDetails'),
      name: 'proDetails'
    }]
  },
  {
    path: '/joinUpIndex',
    component: _import('joinUp/joinUpIndex'),
    children: [{
      path: 'joinUpIndex/:paramId',
      component: _import('joinUp/joinUpIndex'),
      name: 'joinUpIndex'
    }
  ]
  },

  {
    path: '/allPro',
    component: _import('allPro/allPro'),
    children: [{
      path: 'allPro/:paramId',
      component: _import('allPro/allPro'),
      name: 'toAllPro'
    }]
  },
  {
    path: '/workBench',
    component: _import('workBench/index'),
    redirect:'/myProject',
    children: [{
      path: '/workBench',
      component: _import('workBench/myProject/index'),
      children: [{
        path: 'myProject',
        component: _import('workBench/myProject/myproject'),
        name: 'myProject'
      },
      {
        path: 'myContacts',
        component: _import('workBench/myContacts/mycontacts'),
        name: 'myContacts'
      },
      {
        path: 'followup',
        component: _import('workBench/followUp/followup'),
        name: 'followUp'
      },
      {
        path: 'followup',
        component: _import('workBench/myCollect/mycollect'),
        name: 'myCollect'
      }]
    },
    {
      // 项目详情
      path: 'projectDetails',
      component: _import('workBench/myProject/projectDetails'),
      name: 'projectDetails'
    },
    {
      // 编辑项目
      path: 'editproject',
      component: _import('workBench/myProject/editproject'),
      name: 'editproject'
    },
    {
      // 创建项目
      path: 'creatproject',
      component: _import('workBench/myProject/creatproject'),
      name: 'creatproject'
    },
    {
      // 创建人脉
      path: 'createContacts',
      component: _import('workBench/myContacts/createcontacts'),
      name: 'createContacts'
    },
    {
      // 人脉详情
      path: 'contactsDetails',
      component: _import('workBench/myContacts/contactsDetails'),
      name: 'contactsDetails'
    }]
  },
  // {
  //   path: '/',
  //   name:'index',
  //   component: _import('projectLibrary/index'),
  // },
  {
    path: '/',
    name: 'index',
    component: _import('index/index')
  },
  {
    path: '/qr',
    name: 'SmallRoutine',
    component: _import('SmallRoutine/index')
  },
  {
    path: '/login',
    component: _import('login/login'),
    children: [{
      path: '',
      name: 'telephoneLogin',
      component: _import('login/telephoneLogin')
    },
    {
      path: 'codeLogin',
      name: 'codeLogin',
      component: _import('login/codeLogin')
    }]
  },
  {
    path: '/loginReady',
    name: 'loginReady',
    component: _import('login/loginReady')
  },
  {
    path: '/forgetPassword',
    name: 'forgetPassword',
    component: _import('login/forgetPassword')
  },
  {
    path: '/bindTelephone',
    name: 'bindTelephone',
    component: _import('login/bindTelephone')
  },
  {
    path: '/identityChoose',
    name: 'identityChoose',
    component: _import('identity/identityChoose')
  },
  {
    path: '/identityDetail',
    name: 'identityDetail',
    component: _import('identity/identityDetail')
  },
  {
    path: '/API/DD',
    name: 'onekeyResearchAlone',
    component: _import('onekeyResearchAlone/onekeyresearchAlone')
  },
  {
    path: '/onekeyResearch',
    name: 'onekeyResearch',
    component: _import('onekeyResearchAlone/onekeyresearch')
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: _import('aboutUs/aboutUs')
  },
  {
    path: '/emailContact',
    name: 'emailContact',
    component: _import('emailContact/emailContact')
  },
  {
    path: '/addProject',
    name: 'addProject',
    component: _import('addProject/addProject')
  },
  {
    path: '/skipToPc',
    name: 'skipToPc',
    component: _import('skipToPc/skipToPc')
  },
  {
    path: '/personalInformation',
    name: 'personalInformation',
    component: _import('personalInformation/personalInformation')
  },
  {
    path: '/superBP',
    name: 'superBP',
    component: _import('superBp/index') // 超级BP
  },
  {
    path: '/customBp',
    name: 'customBp',
    component: _import('superBp/customBp') // BP问诊/定制
  },
  {
    path: '/creatActivity',
    name: 'creatActivity',
    component: _import('Activity/creatActivity') // 创建活动
  },
  {
    path: '/successActivity',
    name: 'successActivity',
    component: _import('Activity/successActivity') // 我的活动
  },
  {
    path: '/matchActive',
    component: _import('Activity/index'),
    children: [{
      path: '',
      component: _import('Activity/myMatch')
    },
    {
      path: 'myMatch',
      component: _import('Activity/myMatch'),
      name: 'myMatch'
    },
    {
      path: 'myActivity',
      component: _import('Activity/myActivity'),
      name: 'myActivity'
    }]
  },
  {
    path: '/creatMatch',
    name: 'creatMatch',
    component: _import('Activity/creatMatch') // 创建赛事
  },
  {
    path: '/creatMatchActive',
    name: 'creatMatchActive',
    component: _import('Activity/creatMatchActive') // 创建赛事活动
  },
  {
    path: '/matchDetail',
    name: 'matchDetail',
    component: _import('Activity/matchDetail/index') // 赛事详情
  },
  {
    path: '/createJudges',
    name: 'createJudges',
    component: _import('Activity/matchDetail/createJudges') // 创建评委
  },
  {
    path: '/successMatch',
    name: 'successMatch',
    component: _import('Activity/successMatch') // 赛事创建成功
  },
  {
    path: '/allPro',
    name: 'allPro',
    component: _import('allPro/allPro') // 相似项目
  },
  {
    path: '/test',
    name: 'test',
    component: checkone
  }]
});




// WEBPACK FOOTER //
// ./src/router/index.js